<template>
  <div class="carduseMain">
    <div class="tab-box">
      <div class="tab-item" @click="handleClickTab(index)" :class="{'tab-item_actived': index == tabIndex}"
           v-for="(item,index) in tabList" :key="`tab-item_${index}`">{{ item.name }}
      </div>
    </div>
    <div class="content">
      <div class="list-item" v-for="(item,index) in tableData" :key="`list-item_${index}`">
        <div class="before">
          <div class="type">{{ item.amount >= 0 ? '充值' : '退款' }}</div>
          <div class="time">{{ item.time || '-' }}</div>
        </div>
        <div class="money">
          {{ item.amount || '0.000' }}元
        </div>
      </div>
      <div class="more" v-if="tableData.length == 0">暂无更多</div>
    </div>
  </div>
</template>
<script>
import {getUserChongzhi} from "@/api/newApi";
import {formatDate} from "@/utils/formart";

export default {
  data() {
    return {
      tabList: [
        {name: "充值记录"},
        {name: "退款记录"},
      ],
      tabIndex: 0,
      initTableData: [],
      tableData: [],
    };
  },
  computed: {},
  watch: {},
  mounted() {
    this.getUserChongzhi();
  },
  methods: {
    handleClickTab(index) {
      this.tabIndex = index;
      this.handleFilterData()
    },
    handleFilterData() {
      this.tableData = this.initTableData.filter(item => {
        if (this.tabIndex == 0) {
          return item.amount >= 0;
        }else{
          return item.amount < 0;
        }
      })
    },
    getUserChongzhi() {
      getUserChongzhi({
        userId: this.$route.params.id,
        pageNo: 1,
        pageSize: 10,
      }).then((res) => {
        console.log(res);
        // console.log(res.data.records.length);
        if (res.data.records.length > 0) {
          this.initTableData = res.data.records.map((item) => {
            return {
              dataType: item.dataType,
              userName: item.userName,
              mobile: item.mobile,
              amount: item.amount,
              time: item.time,
            };
          });
          this.handleFilterData()
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/sass/state.scss";

.carduseMain {
  padding: 0 $divPadding;
  min-height: 100%;
  background-color: #F5F5F6;

  .tab-box {
    display: flex;
    justify-content: space-around;

    .tab-item {
      padding: $divPadding;

    }

    .tab-item_actived {
      position: relative;
      color: #165DFF;

      &:before {
        content: '';
        position: absolute;
        bottom: 20%;
        left: 0;
        right: 0;
        margin: 0 auto;
        background-color: #165DFF;
        height: 3px;
        width: 20%;
        border-radius: 1rem;
      }
    }
  }

  .content {
    background-color: white;
    border-radius: $borderRadius;
    padding: $divPadding;
    padding-bottom: 0.7rem;

    .list-item {

      display: flex;
      padding: $divPadding 0;
      border-bottom: 1px solid #ECECEC;


      &:first-child {
        padding-top: 0;
      }

      .before {
        flex: 1;

        .type {
          color: #3D3D3D;
          font-size: 0.3783rem;
        }

        .time {
          margin-top: 0.1rem;
          color: #888888;
          font-size: 0.3243rem;
        }
      }

      .money {
        align-self: center;
      }
    }

    .more {
      padding: 0.2rem;
      text-align: center;
      font-size: 0.3243rem;
      color: #cccccc;
    }
  }
}
</style>
